import React from 'react';
import PropTypes from 'prop-types';

import { helpUrl } from '@Constants/CommonConstants';
import { ProjectStatus, ProjectSynthesisJobType } from '@Pages/RetroSynthesis/constants';
import Button from '@Components/Button';
import classnames from 'classnames';
import DialogsWithIcon from '@Containers/Dialogs/DialogsWithIcon';

// eslint-disable-next-line react/prop-types
function DialogMessage({ status }) {
  switch (status) {
    case ProjectStatus.ERROR_RETRY:
      return (
        <>
          Reaxys was unable to process this synthesis job request. Please try submitting the synthesis job again. If the problem persists,
          please contact &nbsp;
          <Button
            buttonConfig={{
              label: 'customer care',
              type: 'link',
              size: 'sm',
              e2eName: 'contact-customer-care',
              aTag: true,
              href: helpUrl,
            }}
            iconConfig={{
              name: 'chevron-right',
            }}
            target="_blank"
          />
        </>
      );
    case ProjectStatus.FATAL_ERROR:
    default:
      return (
        <>
          Reaxys was unable to process this synthesis job request. If the problem persists, please contact &nbsp;
          <Button
            buttonConfig={{
              label: 'customer care',
              type: 'link',
              size: 'sm',
              e2eName: 'contact-customer-care',
              aTag: true,
              href: helpUrl,
            }}
            iconConfig={{
              name: 'chevron-right',
            }}
            target="_blank"
          />
        </>
      );
  }
}

function SynthesisJobRetryDialog({ project, status, type, onRetry = () => null, ...dialogProps }) {
  const { footerClassName, onYesClick, selfClose } = dialogProps;
  return (
    <DialogsWithIcon
      {...dialogProps}
      size="md"
      character="!"
      header="Processing error"
      layoutType="info"
      headerClassName="dialog-with-info-layout-header"
      footerClassName={classnames(footerClassName, 'dialog-with-info-layout-footer-wrapper')}
      footer={
        <div className="els-btn-group-right" tabIndex={0}>
          {status === ProjectStatus.ERROR_RETRY && (
            <Button
              buttonConfig={{ type: 'primary', size: 'sm', label: 'Retry', e2eName: 'dialog-retry' }}
              iconConfig={{ name: 'chevron-right' }}
              onClick={() => {
                onRetry(project.id, type);
                selfClose();
              }}
            />
          )}
          <Button
            buttonConfig={{ type: 'secondary', size: 'sm', label: 'Ok', e2eName: 'dialog-ok' }}
            iconConfig={{ name: 'chevron-right', size: 'tiny' }}
            onClick={onYesClick || selfClose}
          />
        </div>
      }>
      <DialogMessage status={status} />
    </DialogsWithIcon>
  );
}

SynthesisJobRetryDialog.propTypes = {
  project: PropTypes.object,
  status: PropTypes.oneOf(ProjectStatus.allTypes),
  type: PropTypes.oneOf(ProjectSynthesisJobType.allTypes),
  onRetry: PropTypes.func,
};

export default SynthesisJobRetryDialog;
